import { render, staticRenderFns } from "./SurveyDetailForm.vue?vue&type=template&id=48168469&scoped=true&"
import script from "./SurveyDetailForm.vue?vue&type=script&lang=js&"
export * from "./SurveyDetailForm.vue?vue&type=script&lang=js&"
import style0 from "./SurveyDetailForm.vue?vue&type=style&index=0&id=48168469&prod&scoped=true&lang=css&"


/* normalize component */
import normalizer from "!../../../../node_modules/vue-loader/lib/runtime/componentNormalizer.js"
var component = normalizer(
  script,
  render,
  staticRenderFns,
  false,
  null,
  "48168469",
  null
  
)

export default component.exports